/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { type SelectOption } from '@dm/core/types';
import { ToolService } from 'app/common/services';

export enum PasswordComplexE {
    Normal = 0,
    High = 1
}

export enum AccountTypeE {
    User = 0,
    Group = 1,
    ADUser = 2,
    ADGropu = 3
}

@Injectable({ providedIn: 'root' })
export class WindowsLocalAccessUserStrService {
    get = this.i18nService.get;

    i18n = {
        setSecuPolicyClickLab: this.get('service.accessUser_task_setSecuPolicy_click_lab'),
        setSecuPolicyModifySettingsLab: this.get('service.accessUser_task_setSecuPolicy_modifySettings_lab'),
        createBtn: this.get('common.create_button'),
        addBtn: this.get('common.add_button'),
        removeBtn: this.get('common.remove_button'),
        enableBtn: this.get('common.enable_label'),
        disableBtn: this.get('common.disable0_label'),
        setSecurityPolicyBtn: this.get('service.accessUser_task_setSecuPolicy_btn'),
        deleteBtn: this.get('common.delete_button'),
        moreBtn: this.get('common.more_button'),
        modifyBtn: this.get('common.modify_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        closeBtn: this.get('common.close_button'),
        operationBtn: this.get('common.operation_button'),
        selectBtn: this.get('common.select_button'),

        nameLab: this.get('common.name_column'),
        ridLab: this.get('RID'),
        vstoreLab: this.get('common.owningVstore_lab'),
        belongGroupLab: this.get('service.accessUser_task_create_owningGroups_lab'),
        passwordValidityPeriodLab: this.get('settings.securityPolicy_task_username_para_validationTime_label'),
        validityPeriodLab: this.get('settings.securityPolicy_task_username_validationTime_lab'),
        statusLab: this.get('common.status_column'),
        enabledLab: this.get('common.service_enable_value'),
        disabledLab: this.get('common.service_disable_value'),
        descriptionLab: this.get('common.description_column'),
        passwordLab: this.get('common.password_label'),
        confirmPasswordLab: this.get('common.confirmPassword_label'),
        userNamePolicyLab: this.get('service.accessUser_task_setSecuPolicy_userPolicy_lab'),
        passwordPolicyLab: this.get('service.accessUser_task_setSecuPolicy_pswPolicy_lab'),
        loginPolicyLab: this.get('settings.securityPolicy_task_loginPolicy_para_loginPolicy_tab'),
        userNameMinLengthLab: this.get('service.accessUser_task_setSecuPolicy_nameMinLength_lab'),
        passwordLengthLab: this.get('settings.securityPolicy_task_username_para_maxLength_label'),
        complexityLab: this.get('settings.securityPolicy_task_username_para_complexity_label'),
        charactersRepeatTimesLab: this.get('settings.securityPolicy_task_username_para_characterRepeatTimes_label'),
        passwordIncorrectTimesLab: this.get('service.accessUser_task_setSecuPolicy_pswErrorTimes_lab'),
        passwordModifPeriodLab: this.get('settings.securityPolicy_task_username_para_shortestSavingTime_label'),
        passwordLockTimeLab: this.get('service.accessUser_task_setSecuPolicy_idleDays_lab'),
        passwordComplexNormalLab: this.get('service.accessUser_task_setSecuPolicy_pswComplex_low_info_tip'),
        passwordComplexHighLab: this.get('service.accessUser_task_setSecuPolicy_pswComplex_high_info_tip'),
        dayLab: this.get('common.lower_days_label'),
        minuteLab: this.get('common.timeAcount_minutes_label'),
        charLab: this.get('settings.securityPolicy_term_charactersUnit_label'),
        basicLab: this.get('common.basicInfo_title'),
        opreationLab: this.get('common.operation_button'),
        groupType: this.get('common.type_column'),

        createTitle: this.get('service.accessUser_term_localWinAuthUser_create_title'),
        deleteTitle: this.get('service.accessUser_term_localWinAuthUser_delete_title'),
        modifyTitle: this.get('service.accessUser_term_localWinAuthUser_modify_title'),
        setSecurityPolicyTitle: this.get('service.accessUser_task_setSecuPolicy_btn'),
        addGroupTitle: this.get('service.accessUser_task_modify_addOwningGroup_title'),
        removeGroupTitle: this.get('service.accessUser_task_modify_deleteOwningGroup_title'),
        leftGroupTitle: this.get('service.accessUser_task_modify_addOwningGroup_avail_lab'),
        rightGroupTitle: this.get('service.accessUser_task_modify_addOwningGroup_selected_lab'),
        removeTitle: this.get('service.accessUser_task_modify_deleteOwningGroup_title'),


        charactersRepeatTimesTip: this.get('settings.securityPolicy_task_username_repeatNumber_label'),
        zeroTip: this.get('settings.securityPolicy_task_loginPolicy_para_maxSessionNum_range_tip'),
        passwordModifPeriodTip: this.get('service.accessUser_task_setSecuPolicy_shortestSavingTime_tip'),
        passwordIncorrectTimesTip: this.get('service.accessUser_task_setSecuPolicy_pswErrorTimes_tip'),
        passwordLockTimeTip: this.get('service.accessUser_task_setSecuPolicy_idleDays_tip'),
        passwordReversTip: this.get('service.accessUser_task_setSecuPolicy_psw_info_tip'),
        ridTip: this.get('service.accessUser_task_setSecuPolicy_RID_tip'),
        enableTip: this.get('service.accessUser_task_enable_error_tip'),
        disableTip: this.get('service.accessUser_task_disable_error_tip'),
        atLeastSelectOneTip: this.get('common.selectOneObject_lab'),

        nameFormatErr: this.get('service.accessUserGroup_task_name_valid'),
        userNameFormatErr: this.get('service.accessUser_task_name_valid'),

        confirmPasswordErr: this.get('common.pwdNotEqual_tip'),

        deleteMsg: this.get('service.accessUser_task_deleteWinUser_confirm_msg'),
        removeMsg: this.get('service.accessUser_task_removeWinUser_fromWinGroup_confirm_msg'),
        removeFromGroupMsg: this.get('service.accessUser_task_removeGroup_fromUserBelongGroup_confirm_msg'),

        setSecurityPolicyResult: this.get('rest.setSecurityPolicy_msg'),
    };

    statusOpts: SelectOption[] = [
        {
            label: this.i18n.enabledLab,
            value: true,
        },
        {
            label: this.i18n.disabledLab,
            value: false,
        },
    ];

    passwordComplexOpts: SelectOption[] = [
        {
            label: this.i18n.passwordComplexNormalLab,
            value: PasswordComplexE.Normal,
        },
        {
            label: this.i18n.passwordComplexHighLab,
            value: PasswordComplexE.High,
        },
    ];

    /**
     * 组类型
     * 1 内置组,
     * 2 自定义组
     */
    groupTypeOpt = [
        {
            value: '1',
            label: this.get('service.accessUser_userGroupType_default_value'),
        },
        {
            value: '2',
            label: this.get('service.accessUser_userGroupType_userCreate_value'),
        },
    ];

    constructor(
        private i18nService: I18nService,
        private toolService: ToolService,
    ) {}

    /**
     * 创建结果
     * @param name 用户名
     */
    createResult(name: string): string {
        return this.get('rest.createWinLocalAuthUser_msg', [name]);
    }

    /**
     * 添加到主组结果
     * @param name 用户名
     * @param group 主组
     */
    addToGroupResult(name: string, group: string): string {
        return this.get('rest.addWinLocalAuthUserToOwnGroup_msg', [name, group]);
    }

    /**
     * 删除结果
     * @param name
     */
    deleteResult(name: string): string {
        return this.get('rest.deleteWinLocalAuthUser_msg', [name]);
    }

    /**
     * 修改用户结果
     * @param name
     */
    modifyResult(name: string): string {
        return this.get('rest.modifyWinLocalAuthUser_msg', [name]);
    }

    /**
     * 移除用户结果
     * @param name
     */
    removeGroupResult(groupName: string, memberName: string): string {
        return this.get('rest.removeMemberfromWinLocalAuthGroup_msg', [groupName, memberName]);
    }

    /**
     * 修改用户状态
     * @param name
     * @param enabledStatus
     */
    modifyStatusResult(name: string, enabledStatus: boolean): string {
        return this.get(enabledStatus ? 'rest.enableWinLocalAuthUser_msg' : 'rest.disableWinLocalAuthUser_msg', [name]);
    }

    /**
     * xx天数
     */
    daysRender = (value: string): string => this.toolService.isInvalidNum(value)
        ? this.i18nService.get('common.EnumDefine_USER_STATE_E_PWD_NEVER_INVALID')
        : this.i18nService.get('common.validity_day_value', [value]);

    /**
     * 范围提示
     */
    rangeTip = (min: number | string, max: number | string): string => this.get('common.valueRange_label', [min, max]);

    /**
     * 字符重复次数错误
     */
    chartRepeatErr = (count: number): string => this.get('common.newPassword_short_tip5', [count]);
}
